import React, { ReactNode, useEffect, useRef, useState } from 'react';
import { createUseStyles } from 'react-jss';
import { mediaMinWidth } from '../theme/utils';
import { SIDE_NAV_WIDTH } from '../navigation/NavConstants';
import { IThemeColor } from '../theme/IThemeColor';

const useStyles = createUseStyles({
    header: {
        top: 0,
        left: 0,
        width: '100vw',
        margin: 0,
        zIndex: 100,

        paddingLeft: 'var(--ion-padding, 16px)',
        paddingRight: 'var(--ion-padding, 16px)',

        [mediaMinWidth.md]: {
            paddingLeft: '15%',
            paddingRight: '15%'
        },

        [mediaMinWidth.lg]: {
            paddingLeft: `calc(${SIDE_NAV_WIDTH}px + 20%)!important`,
            paddingRight: '20%'
        }
    }
});

export const FullWidthHeader: React.FC<{color?: IThemeColor, fixed?: boolean, children: ReactNode}> = ({ fixed, color, children }) => {
    const classes = useStyles();

    const contentRef = useRef<HTMLDivElement>(null);
    const [height, setHeight] = useState(50);

    const position = (fixed ? 'fixed' : 'absolute');
    const borderBottom = (fixed ? '1px solid var(--ion-color-step-150)' : undefined);
    const background = (color ? `rgba(var(--ion-color-${color}-rgb), 0.9)` : 'white');

    useEffect(() => {
        // need timeout to be sure we get the final clientHeight after all rendering is done
        setTimeout(() => {
            setHeight(contentRef.current?.clientHeight || height);
        }, 50);
    }, [contentRef, height]); // eslint-disable-line react-hooks/exhaustive-deps

    if (!children) {
        return;
    }

    return (
        <>
            <div ref={contentRef} className={classes.header} style={{position, borderBottom, background}}>
                {children}
            </div>

            {/* re-render hidden with position relative, to push page content down so it's not behind the header */}
            <div className={classes.header} style={{position: 'relative', visibility: 'hidden', height}}>
                &nbsp;
            </div>
        </>
    );
};
